import { render, staticRenderFns } from "./EmpresaFiscal.vue?vue&type=template&id=322695bf&scoped=true"
import script from "./EmpresaFiscal.vue?vue&type=script&lang=js"
export * from "./EmpresaFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322695bf",
  null
  
)

export default component.exports